module.exports = __webpack_public_path__ + "pk.svg?f76952932734f7ef0d655691158a4371";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-flag-icon/node_modules/flag-icon-css/flags/1x1/pk.svg
// module id = 1565
// module chunks = 0